/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Table_StatusInputs */

const en_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const fr_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const it_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const ru_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const es_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const zh_cn2_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

const ja_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const hi_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const pt_pt2_work_order_publish_table_status = /** @type {(inputs: Work_Order_Publish_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Work_Order_Publish_Table_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_table_status = /** @type {((inputs?: Work_Order_Publish_Table_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Table_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_table_status(inputs)
	if (locale === "de") return de_work_order_publish_table_status(inputs)
	if (locale === "it") return it_work_order_publish_table_status(inputs)
	if (locale === "ru") return ru_work_order_publish_table_status(inputs)
	if (locale === "es") return es_work_order_publish_table_status(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_table_status(inputs)
	if (locale === "ja") return ja_work_order_publish_table_status(inputs)
	if (locale === "hi") return hi_work_order_publish_table_status(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_table_status(inputs)
	return en_work_order_publish_table_status(inputs)
});